import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface SigningMethodSelectProps {
  signingMethod: "email" | "direct";
  onMethodChange: (value: "email" | "direct") => void;
  disabled?: boolean;
}

export function SigningMethodSelect({ 
  signingMethod, 
  onMethodChange,
  disabled 
}: SigningMethodSelectProps) {
  return (
    <div className="grid gap-2">
      <Label>Velg signeringsmetode</Label>
      <RadioGroup
        value={signingMethod}
        onValueChange={(value) => onMethodChange(value as "email" | "direct")}
        className="grid gap-2"
        disabled={disabled}
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="email" id="email" />
          <Label htmlFor="email">Send til e-post</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="direct" id="direct" />
          <Label htmlFor="direct">Signer direkte med BankID</Label>
        </div>
      </RadioGroup>
    </div>
  );
}